'use client';

import React, { useEffect, useState } from 'react';
import { useSiteLanguage } from '../../../lib/SiteLanguageContext';
import Link from 'next/link';
import Image from 'next/image';

const Footer = () => {
    const [year, setYear] = useState<string>('');

    useEffect(() => {
        setYear(new Date().getFullYear().toString());
    }, []);

    const { siteLang } = useSiteLanguage();
    const t = siteLang === 'en' ? {
        siteName: 'Studies of Defense Systems',
        motto: 'Knowledge, not propaganda.',
        content: 'Content',
        armament: 'Armament',
        ammunition: 'Ammunition',
        enterprises: 'Defense Enterprises',
        history: 'Military History',
        about: 'About Us',
        contact: 'Contact',
        team: 'Team',
        rights: 'All rights reserved.',
        privacy: 'Privacy Policy',
        terms: 'Terms of Use',
        cookies: 'Privacy and cookie settings',
    } : {
        siteName: 'Studije odbrambenih sistema',
        motto: 'Znanje, a ne propaganda.',
        content: 'Sadržaj',
        armament: 'Naoružanje',
        ammunition: 'Municija',
        enterprises: 'Namjenska preduzeća',
        history: 'Vojna istorija',
        about: 'O nama',
        contact: 'Kontakt',
        team: 'Tim',
        rights: 'Sva prava zadržana.',
        privacy: 'Politika privatnosti',
        terms: 'Uslovi korišćenja',
        cookies: 'Privacy and cookie settings',
    };

    return (
        <footer
            style={{ backgroundColor: '#111827' }}
            className="text-white"
        >
            <div className="w-full px-4 lg:px-8 py-8">
                <div className="grid sm:grid-cols-2 lg:grid-cols-6 gap-8 mb-6">
                    <div className="lg:col-span-2">
                        <div className="flex items-start space-x-3 mb-4">
                            <div className="relative w-12 h-12">
                                <Image src="/Logo.png" alt="logo" width={48} height={48} priority className="object-contain" />
                            </div>

                            <div>
                                <span className="text-xl font-bold" style={{ fontFamily: 'Armalite Rifle, sans-serif' }}>
                                    {t.siteName}
                                </span>
                                <p className="text-sm text-white/90 mt-2 max-w-sm">
                                    {t.motto}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-4 uppercase tracking-wide text-sm">{t.content}</h4>
                        <ul className="space-y-2">
                            <li>
                                <Link href="/articles/weapons" className="text-sm text-white/80 hover:text-white transition">{t.armament}</Link>
                            </li>
                            <li>
                                <Link href="/articles/ammunition" className="text-sm text-white/80 hover:text-white transition">{t.ammunition}</Link>
                            </li>
                            <li>
                                <Link href="/articles/enterprises" className="text-sm text-white/80 hover:text-white transition">{t.enterprises}</Link>
                            </li>
                            <li>
                                <Link href="/articles/history" className="text-sm text-white/80 hover:text-white transition">{t.history}</Link>
                            </li>
                        </ul>
                    </div>



                    <div>
                        <h4 className="font-semibold mb-4 uppercase tracking-wide text-sm">{t.siteName}</h4>
                        <ul className="space-y-2">
                            <li>
                                <Link href="/o-nama" className="text-sm text-white/80 hover:text-white transition">{t.about}</Link>
                            </li>
                            <li>
                                <Link href="/kontakt" className="text-sm text-white/80 hover:text-white transition">{t.contact}</Link>
                            </li>
                            <li>
                                <Link href="/tim" className="text-sm text-white/80 hover:text-white transition">{t.team}</Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-6 border-t border-white/10">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                        <p className="text-sm text-white/70">© {year} {t.siteName}. {t.rights}</p>

                        <div className="flex space-x-6 text-sm">
                            <Link href="/politika-privatnosti" className="text-white/70 hover:text-white">{t.privacy}</Link>
                            <Link href="/uslovi-koriscenja" className="text-white/70 hover:text-white">{t.terms}</Link>
                            <Link href="/privacy-cookie-settings" className="text-white/70 hover:text-white">{t.cookies}</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
